import Routes from './routes';
import ThemeCustomization from './themes';
import Locales from './components/Locales';
import ScrollTop from './components/ScrollTop';
import Snackbar from './components/@extended/Snackbar';
import { AuthProvider } from './auth/useAuth';
import { QueryClientProvider } from './query/ClientProvider';
import { FC } from 'react';
import { Announcement } from './announcement/Announcement';
import { Stack } from '@mui/material';
import { HelmetWrapper } from './HelmetWrapper';
import 'yet-another-react-lightbox/styles.css';
import { CookiesProvider } from 'react-cookie';

import { GoogleOAuthProvider } from '@react-oauth/google';
import config from './config/config';
import { AntdConfig } from './AntdConfig';
import { useBrowserLocale } from './hooks/useBrowserLocale';
import { getEnvironmentDomain } from './utils/getEnvironmentDomain';

const inThreeMonths = new Date(Date.now());
inThreeMonths.setMonth(inThreeMonths.getMonth() + 3);

const App: FC = () => {
	useBrowserLocale();

	return (
		<CookiesProvider defaultSetOptions={{ path: '/', sameSite: 'lax', domain: getEnvironmentDomain(), expires: inThreeMonths }}>
			<ThemeCustomization>
				<AntdConfig>
					<GoogleOAuthProvider clientId={config.google.clientId}>
						<Locales>
							<QueryClientProvider>
								<AuthProvider>
									<HelmetWrapper>
										<ScrollTop>
											<Stack height={{ sm: '100svh' }} flexDirection={'column'}>
												<Announcement />
												<Routes />
											</Stack>
											<Snackbar />
										</ScrollTop>
									</HelmetWrapper>
								</AuthProvider>
							</QueryClientProvider>
						</Locales>
					</GoogleOAuthProvider>
				</AntdConfig>
			</ThemeCustomization>
		</CookiesProvider>
	);
};

export default App;
